module.exports = __webpack_public_path__ + "img/Picture1.e4af4deb.jpg";